import { useUpdateReportConfiguration } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import type { UpdateReportConfigurationRequestType } from 'src/api/generated/touring/types';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.UPDATE_REPORT_MAILING';

type UseUpdateReportMailingReturnType = {
  // Resolves to true on success so the caller only closes the modal then.
  updateReportMailing: (
    configurationId: string,
    data: UpdateReportConfigurationRequestType
  ) => Promise<boolean>;
};

// The configurations refetch is triggered by the generated mutation (see orval.config.ts).
export const useUpdateReportMailing = (): UseUpdateReportMailingReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutateAsync } = useUpdateReportConfiguration<AxiosError>();

  const updateReportMailing = async (
    configurationId: string,
    data: UpdateReportConfigurationRequestType
  ) => {
    try {
      await mutateAsync({ configurationId, data });
    } catch (error) {
      showError({
        title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
        error: error as AxiosError,
      });
      return false;
    }

    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
    return true;
  };

  return { updateReportMailing };
};
